var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import './NotificationCard.js';
let NotificationPreview = class NotificationPreview extends LitElement {
    constructor() {
        super(...arguments);
        this.notifications = [];
        this.unreadCount = 0;
        this.isMarkingAll = false;
    }
    async handleMarkAllAsRead() {
        if (this.isMarkingAll || !this.apiService)
            return;
        const unreadNotifications = this.notifications.filter(n => !n.read);
        if (unreadNotifications.length === 0)
            return;
        this.isMarkingAll = true;
        try {
            await Promise.all(unreadNotifications.map(n => this.apiService.put(`/notification-status/${n.notification_id}`, { read: true })));
            this.dispatchEvent(new CustomEvent('all-read', {
                bubbles: true,
                composed: true,
            }));
        }
        catch (err) {
            console.error('Failed to mark all notifications as read:', err);
        }
        finally {
            this.isMarkingAll = false;
        }
    }
    handleSeeMore() {
        this.dispatchEvent(new CustomEvent('see-more-click', {
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        const hasNotifications = this.notifications.length > 0;
        const hasUnread = this.notifications.some(n => !n.read);
        return html `
      <div class="notification-preview">
        <div class="notification-preview__header">
          <h3 class="notification-preview__title">
            ${msg('Notifications', { id: 'notification.preview.title' })}
            ${this.unreadCount > 0
            ? html `<span class="notification-preview__badge">${this.unreadCount}</span>`
            : nothing}
          </h3>
          ${hasUnread
            ? html `
                <button
                  class="notification-preview__mark-all"
                  @click="${this.handleMarkAllAsRead}"
                  ?disabled="${this.isMarkingAll}"
                >
                  ${this.isMarkingAll
                ? msg('Marking...', { id: 'notification.preview.markingAll' })
                : msg('Mark all as read', { id: 'notification.preview.markAllRead' })}
                </button>
              `
            : nothing}
        </div>

        ${hasNotifications
            ? html `
              <div class="notification-preview__list">
                ${this.notifications.map(notification => html `
                    <notification-card
                      .notification="${notification}"
                      .apiService="${this.apiService}"
                    ></notification-card>
                  `)}
              </div>
            `
            : html `
              <div class="notification-preview__empty">
                ${msg('No new notifications', { id: 'notification.preview.empty' })}
              </div>
            `}

        <div class="notification-preview__footer">
          <button class="notification-preview__see-more" @click="${this.handleSeeMore}">
            ${msg('See more', { id: 'notification.preview.seeMore' })}
          </button>
        </div>
      </div>
    `;
    }
};
NotificationPreview.styles = css `
    :host {
      display: block;
    }

    .notification-preview {
      min-width: 350px;
      max-width: 420px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      overflow: hidden;
    }

    .notification-preview__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 14px 16px;
      border-bottom: 1px solid #eee;
    }

    .notification-preview__title {
      margin: 0;
      font-size: 0.95rem;
      font-weight: 600;
      color: #333;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .notification-preview__badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 20px;
      height: 20px;
      padding: 0 6px;
      border-radius: 10px;
      background: #F44336;
      color: #fff;
      font-size: 0.7rem;
      font-weight: 600;
    }

    .notification-preview__mark-all {
      background: none;
      border: none;
      font-size: 0.75rem;
      color: #1976D2;
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 4px;
    }

    .notification-preview__mark-all:hover {
      background: #E3F2FD;
    }

    .notification-preview__mark-all:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .notification-preview__list {
      display: flex;
      flex-direction: column;
      gap: 1px;
      background: #f5f5f5;
    }

    .notification-preview__list notification-card {
      background: #fff;
    }

    .notification-preview__empty {
      padding: 32px 16px;
      text-align: center;
      color: #999;
      font-size: 0.85rem;
    }

    .notification-preview__footer {
      padding: 10px 16px;
      text-align: center;
      border-top: 1px solid #eee;
    }

    .notification-preview__see-more {
      background: none;
      border: none;
      font-size: 0.8rem;
      color: #1976D2;
      cursor: pointer;
      font-weight: 500;
      padding: 4px 12px;
      border-radius: 4px;
    }

    .notification-preview__see-more:hover {
      background: #E3F2FD;
    }
  `;
__decorate([
    property({ type: Array })
], NotificationPreview.prototype, "notifications", void 0);
__decorate([
    property({ type: Number })
], NotificationPreview.prototype, "unreadCount", void 0);
__decorate([
    property({ type: Object })
], NotificationPreview.prototype, "apiService", void 0);
__decorate([
    state()
], NotificationPreview.prototype, "isMarkingAll", void 0);
NotificationPreview = __decorate([
    localized(),
    customElement('notification-preview')
], NotificationPreview);
export { NotificationPreview };
//# sourceMappingURL=NotificationPreview.js.map